import React, { useContext } from 'react';
import Traductor from '../Traductor';
import '../../css/components/shared/VehicleTotalPrice.css';
import { UserContext } from '../../contexts/UserContext';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';


const printAutocreditInfo = (vehicle, t) => 
{
    let rows = [];

    if( vehicle.AutoCredit===1){

        rows.push(
            <div className="o-layout">
                    <div className="o-layout__item u-1/2 u-text-left">
                        <p className="u-m-none">
                            {t.getTraduction('DamagesToReturn')}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/2 u-text-right">
                        <p className="u-m-none">
                            {vehicle.TotalDamageAmount >= 0
                                ? formatPrice(vehicle.TotalDamageAmount)
                                : formatPrice(0)}
                        </p>
                    </div>
                </div>        
            );
        if(vehicle.SellAutoCreditVWR)
        {                          
            if(vehicle.SellAutoCreditVWRMode===1)
            {
                rows.push(
                    <div className="o-layout">
                            <div className="o-layout__item u-1/2 u-text-left">
                                <p className="u-m-none">
                                    {t.getTraduction('SalesRegime')}
                                </p>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-right">
                                <p className="u-m-none">
                                {t.getTraduction('REBU')}
                                </p>
                            </div>
                        </div>        
                    );                   
            }
            if(vehicle.SellAutoCreditVWRMode===2)
            {
                rows.push(
                    <div className="o-layout">
                            <div className="o-layout__item u-1/2 u-text-left">
                                <p className="u-m-none">
                                    {t.getTraduction('SalesRegime')}
                                </p>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-right">
                                <p className="u-m-none">
                                {t.getTraduction('REG')}
                                </p>
                            </div>
                        </div>        
                    );                    
            }
            rows.push(
                <div className="o-layout">
                        <div className="o-layout__item u-1/2 u-text-left">
                            <p className="u-m-none">
                                {t.getTraduction('PenaltyForDismissalAutocredit')}
                            </p>
                        </div>
                        <div className="o-layout__item u-1/2 u-text-right">
                            <p className="u-m-none">
                            {vehicle.RepurchaseObligationPrice >= 0
                    ? formatPrice(vehicle.RepurchaseObligationPrice)
                    : formatPrice(0)}
                            </p>
                        </div>
                    </div>        
                ); 
                rows.push(
                    <div className="o-layout">
                            <div className="o-layout__item u-1/2 u-text-left">
                                <p className="u-m-none">
                                    {t.getTraduction('VehiclesellVWRPrice')}
                                </p>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-right">
                                <p className="u-m-none">
                                {formatPrice(vehicle.Price - vehicle.Price*0.03 - vehicle.TotalDamageAmount)}
                                </p>
                            </div>
                        </div>        
                    ); 
        }
       
    }
    return rows; 
};

function VehicleTotalPrice({ vehicle, transportPrice = 0 }) {
    const { user } = useContext(UserContext);
    const t = new Traductor();

    return (
        <div className="c-vehicle-total-price">
            <hr />
            <div className="o-layout">
                <div className="o-layout__item u-1/2 u-text-left">
                    <p className="u-m-none">
                        {t.getTraduction('VehiclePrice')}
                    </p>
                </div>
                <div className="o-layout__item u-1/2 u-text-right">
                    <p className="u-m-none">
                        {formatPrice(vehicle?.Price || 0)}
                    </p>
                </div>
            </div>
            {(user.buyerType == 2 ||
                user.buyerType == 8 ||
                user.buyerType == 7) &&
                transportPrice > 0 && (
                    <div className="o-layout">
                        <div className="o-layout__item u-1/2 u-text-left">
                            <p className="u-m-none">
                                {t.getTraduction('Transport')}
                            </p>
                        </div>
                        <div className="o-layout__item u-1/2 u-text-right">
                            <p className="u-m-none">
                                {transportPrice >= 0
                                    ? formatPrice(transportPrice)
                                    : formatPrice(0)}
                            </p>
                        </div>
                    </div>
                )}
                {(!vehicle.SellAutoCreditVWR) && (
            <div className="o-layout">
                <hr />
                <div className="o-layout__item u-1/2 u-text-left">
                    <p className="u-m-none">
                        <strong>{t.getTraduction('Total')}</strong>
                    </p>
                </div>
                <div className="o-layout__item u-1/2 u-text-right">
                    <p className=" u-text-bold u-m-none">
                        {formatPrice(vehicle?.Price + transportPrice)}
                    </p>
                </div>
            </div>)}

            {printAutocreditInfo(vehicle,t)}
        </div>
    );
}

export default VehicleTotalPrice;
